import React, { useContext } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { LayoutContext } from '../../../../context/LayoutContext'
import DateRange from './DateRange'
import OrdersTotals from './OrdersTotals'
import Clients from './Clients'
import PaymentMethods from './PaymentMethods'
import Pharmacies from './Pharmacies'
import States from './States'
import Cities from './Cities'
import { defaultFormatTimeZone } from '../../../../utils/consts'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'left',
      color: theme.palette.text.primary
    },
    container: {
      display: 'flex',
      justifyContent: 'flex-start'
    }
  })
)

export default function Filters (): JSX.Element {
  const classes = useStyles()
  const { setFilters } = useContext(DailyMonitoringFiltersContext)
  const { layout, setLayout } = useContext(LayoutContext)

  const handleChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setLayout({
      isFilterOpen: isExpanded
    })
  }

  const cleanHandler = () => {
    setFilters({
      pharmacies: [],
      states: [],
      cities: [],
      orderStatus: null,
      clients: [],
      paymentMethods: [],
      dateRange: {
        initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
        finalDate: moment().clone().format('YYYY-MM-DD'),
        ...defaultFormatTimeZone
      },
      orderCount: [0, 300],
      orderTotals: {
        initial: 0,
        final: 4000
      }
    })

    window.sessionStorage.removeItem('initial_date_picker')
    window.sessionStorage.removeItem('final_date_picker')
  }

  return (
    <div className={classes.root}>
      <Accordion className={classes.paper} expanded={layout.isFilterOpen} onChange={handleChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography paragraph>Filtros</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1} className={classes.container}>
            <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              <Grid item sm={12} md={6}>
                <DateRange />
              </Grid>
              <Grid item sm={12} md={5}>
                <Pharmacies />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              <Grid item sm={12} md={6}>
                <Clients />
              </Grid>
              <Grid item sm={12} md={5}>
                <PaymentMethods />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              <Grid item sm={12} md={6}>
                <States />
              </Grid>
              <Grid item sm={12} md={5}>
                <Cities />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              {/* <Grid item sm={12} md={6}>
                <OrdersQuantity />
              </Grid> */}
              <Grid item sm={12} md={12}>
                <OrdersTotals />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="flex-end" className={classes.item}>
              <Button color="secondary" onClick={cleanHandler}>limpar</Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
